import { Box, Divider, Grid, ReadOnlyField, Text } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { CompanyType, Exchange } from '@bcba/types';
import React, { FC } from 'react';

interface SignUpRequestGeneralCompanyInfoProps {
  companyName: string;
  companyFiscalId: string;
  companyStreetName: string;
  companyStreetNumber: string;
  companyPostalCode: string;
  exchange: Exchange;
  companyType: CompanyType;
}

export const SignUpRequestGeneralCompanyInfo: FC<
  SignUpRequestGeneralCompanyInfoProps
> = (props) => {
  const { t } = useTranslation();
  const {
    companyName,
    companyFiscalId,
    companyStreetName,
    companyStreetNumber,
    companyPostalCode,
    exchange,
    companyType,
  } = props;

  return (
    <>
      <Box mb={6}>
        <Text size="md" variant="medium" color="content-primary" mb={4}>
          {t('signUpRequest.generalCompanyInformation')}
        </Text>
        <Divider />
      </Box>
      <Grid
        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
        gridGap={6}
      >
        <ReadOnlyField label={t('common.company.name')} value={companyName} />
        <ReadOnlyField
          label={t('common.company.fiscalId')}
          value={companyFiscalId}
        />
        <ReadOnlyField
          label={t('common.company.streetName')}
          value={companyStreetName}
        />
        <ReadOnlyField
          label={t('common.company.streetNumber')}
          value={companyStreetNumber}
        />
        <ReadOnlyField
          label={t('common.company.postalCode')}
          value={companyPostalCode}
        />
        <ReadOnlyField
          label={t('common.company.exchange')}
          value={t(`exchange.${exchange}`)}
        />
        <ReadOnlyField
          label={t('common.company.companyType')}
          value={t(`companyTypes.${companyType}`)}
        />
      </Grid>
    </>
  );
};

export default SignUpRequestGeneralCompanyInfo;
